module.exports = __webpack_public_path__ + "static/kran03_512-589d004485d13dd405bdebecdc5dbd86.jpg";